import { render, staticRenderFns } from "./BreadcrumbsMenu.vue?vue&type=template&id=49f20246&"
import script from "./BreadcrumbsMenu.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports